import { render, staticRenderFns } from "./meal-more-spec-panel.vue?vue&type=template&id=406639ce&scoped=true&"
import script from "./meal-more-spec-panel.vue?vue&type=script&lang=js&"
export * from "./meal-more-spec-panel.vue?vue&type=script&lang=js&"
import style0 from "./meal-more-spec-panel.vue?vue&type=style&index=0&id=406639ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406639ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406639ce')) {
      api.createRecord('406639ce', component.options)
    } else {
      api.reload('406639ce', component.options)
    }
    module.hot.accept("./meal-more-spec-panel.vue?vue&type=template&id=406639ce&scoped=true&", function () {
      api.rerender('406639ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/meal-more-spec-panel.vue"
export default component.exports